import NavigationService from "./NavigationService";
import UiService from "./UiService";
import StoreService from "./StoreService";
import PropertyService from "./PropertyService";
import AppService from "./AppService";
import AssetService from "./AssetService";
import { Application, AppModule, BootParams } from "./AppModule";
import MyRequestsService from "./MyRequestsService";

export { NavigationService, UiService };


const cfg: { bootParam?: BootParams, modules: AppModule[] } = {
	modules: [],
};

export function initApp( app: Application ) {
	cfg.bootParam = {
		app: app,
		navigationService: NavigationService,
		uiService: UiService,
		storeService: StoreService,
		propertyService: PropertyService,
		appService: AppService,
		assetService: AssetService,
		myRequestsService: MyRequestsService,
	};
}


export function addModule( module: AppModule ) {
	if ( cfg.bootParam == null ) throw new Error( "Application is not configured" );
	cfg.modules.push( module );
}

function initModule( module: AppModule ) {
	if ( cfg.bootParam == null ) throw new Error( "Application is not configured" );
	module.registerModule( cfg.bootParam! );

}

export function preInit() {
	const services = Object.values( cfg.bootParam! );
	for ( const service of services ) {
		if ( service.onPreInit ) {
			service.onPreInit();
		}
	}
	const modules = cfg.modules;
	for ( const module of modules ) {
		if ( module.onPreInit ) {
			module.onPreInit( cfg.bootParam! );
		}
	}
}

export function preInitDone() {
	const services = Object.values( cfg.bootParam! );
	for ( const service of services ) {
		if ( service.onPreInitDone ) {
			service.onPreInitDone();
		}
	}
	const modules = cfg.modules;
	for ( const module of modules ) {
		if ( module.onPreInitDone ) {
			module.onPreInitDone( cfg.bootParam! );
		}
	}
}

export function initModules() {
	const modules = cfg.modules;
	for ( const module of modules ) {
		initModule( module );
	}
}

export function initDone() {
	const services = Object.values( cfg.bootParam! );
	for ( const service of services ) {
		if ( service.onInitDone ) {
			service.onInitDone();
		}
	}
	const modules = cfg.modules;
	for ( const module of modules ) {
		if ( module.onInitDone ) {
			module.onInitDone( cfg.bootParam! );
		}
	}
}

export function getAppServices() {
	return cfg.bootParam!;
}

declare module "@10x/coreapp" {
	interface AppReducer {

	}
}
